import { Component, Input, TemplateRef } from '@angular/core';
import { IToolbarData } from '../../models/components-data.models';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
  @Input() toolbarData: IToolbarData;
  @Input() template: TemplateRef<any>;
  @Input() recipient?: object;
  @Input() lastChatTime?: number;

  constructor(private router: Router) {}

  onClickBack() {
    // If we're in a chat detail page, always navigate to /chat
    if (this.router.url.includes('/chat/detail/')) {
      this.router.navigate(['/chat'], { replaceUrl: true });
    } else if (this.toolbarData.arrowRouter === 'back') {
      // Special handling for back navigation
      const previousUrl = sessionStorage.getItem('previousUrl');

      // Check if current page is unverified page
      if (this.router.url.startsWith('/chat/unverified')) {
        // Using window.history.back() directly for unverified page to avoid navigation loops
        if (previousUrl === '/chat') {
          sessionStorage.removeItem('previousUrl');
          this.router.navigateByUrl('/', { replaceUrl: true });
        } else if (previousUrl && !previousUrl.includes('/chat/unverified')) {
          this.router.navigateByUrl(previousUrl, { replaceUrl: true });
          sessionStorage.removeItem('previousUrl');
        } else {
          window.history.back();
        }
      } else if (previousUrl && previousUrl !== this.router.url) {
        // Use the stored previous URL if available and it's not the current URL
        this.router.navigateByUrl(previousUrl);
        sessionStorage.removeItem('previousUrl');
      } else {
        // Use browser history API as fallback
        window.history.back();
      }
    } else {
      this.router.navigate([this.toolbarData.arrowRouter], {
        replaceUrl: true,
      });
    }
  }

  getTimeDiffStr(time) {
    if (time === -1) {
      return '';
    } else if (time === 0) {
      return 'Start the conversation!';
    } else {
      const timeDiff = Date.now() - time;
      if (timeDiff < 60 * 1000) {
        return 'Seen just now';
      } else if (timeDiff < 60 * 60 * 1000) {
        const minutes = Math.floor(timeDiff / (60 * 1000));
        return `Seen ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
      } else if (timeDiff < 60 * 60 * 24 * 1000) {
        const hours = Math.floor(timeDiff / (60 * 60 * 1000));
        return `Seen ${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
      } else {
        const days = Math.floor(timeDiff / (60 * 60 * 24 * 1000));
        return `Seen ${days} ${days === 1 ? 'day' : 'days'} ago`;
      }
    }
  }
}

